import { ErhlPropertyType } from '@/helpers/const';

import type { PropertyDetailEntry } from '@/types';

/**
 * Retirement, land-lease or community home properties are not taken as security (JS-9416), so an
 * application purchasing one needs at least one other property providing security.
 */
export function requiresSupportingProperty(purchaseProperties: PropertyDetailEntry[]): boolean {
  return purchaseProperties.some(
    (property) => property.propertyType === ErhlPropertyType.RETIREMENT_LAND_LEASE_COMMUNITY_HOME,
  );
}
